import { render, staticRenderFns } from "./ExpressOrderAdd.vue?vue&type=template&id=436d50a7&scoped=true&"
import script from "./ExpressOrderAdd.vue?vue&type=script&lang=js&"
export * from "./ExpressOrderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d50a7",
  null
  
)

export default component.exports